import { Trans, useTranslation } from "react-i18next"

import util from "utils/utils"

export default function IdeaVotedContent({ events, ownerIdea = { name: "Unknown" } }) {
  const { t } = useTranslation()
  const textSuffix = events[0]?.isFollower ? `${t("generic.ideaWithArticle")} you follow` : `your ${t("generic.idea")}`
  return (
    <Trans i18nKey="notifications.ideaVoted">
      <b>{{ name: util.getEventNames(events) }}</b> liked {{ suffix: textSuffix }} <b> {{ idea: ownerIdea.name }}</b>
    </Trans>
  )
}
